<script context="module">
	import { z } from "zod";
	export const name = "Titlu";
	export const CustomFields = z.object({
		link: z
			.object({
				url: z.string().optional(),
				target: z.string().optional(),
			})
			.optional(),
	});
</script>

<script>
	import { getContext } from "svelte";
	import { replaceContext, stripTags } from "@reperio-news/core.components/includes/Helpers";

	export let data = {};
	export let id = undefined;
	export let type = undefined;
	export let indexInContainer = undefined;
	type || indexInContainer;

	const context = getContext("context");

	$: text = data && data.title ? stripTags(replaceContext(data.title, $context), []) : "";
	$: element = (data && data.element) || "h2";
	$: link = data && data.custom_fields && data.custom_fields.link && data.custom_fields.link.url;
</script>

{#if text}
	{#if element === "h1"}
		<h1 class="af-title af-title--display" {id}>{text}</h1>
	{:else if element === "h3"}
		<h3 class="af-title af-heading" {id}>
			{#if link}<a href={link} target={data.custom_fields.link.target || undefined}>{text} <span aria-hidden="true">→</span></a>{:else}{text}{/if}
		</h3>
	{:else}
		<h2 class="af-title af-heading" {id}>
			{#if link}<a href={link} target={data.custom_fields.link.target || undefined}>{text} <span aria-hidden="true">→</span></a>{:else}{text}{/if}
		</h2>
	{/if}
{/if}

<style lang="scss">
	.af-title {
		width: 100%;
		grid-column: 1 / -1;
	}

	.af-title--display {
		font: 600 var(--af-text-display) / var(--af-leading-tight) var(--af-font-serif-display);
		color: var(--af-ink);
	}

	.af-heading a:hover {
		color: var(--af-brand);
	}
</style>
